import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { useNavigate, useParams } from "react-router-dom";
import { userDataAtom } from "@/recoil/atom/userDataAtom";
import { fetchData } from "@/lib/helper";
import config from "@/config";
import ClubInviteScreen from "@/components/journey/ClubInviteScreen";
import NotFoundScreen from "@/components/common/screens/NotFoundScreen";
import TenantDetailsScreen from "@/components/journey/TenantDetailsScreen";
import Profile from "@/components/journey/Profile";
import DynamicScreen from "@/components/common/screens/DynamicScreen";

const ALL_CONFIG_PATHS = [
  "about",
  "update-landlord",
  "renting-status",
  "invite",
  "landlord-details",
  "property-details",
  "rent-details",
  "eligibility-check",
  "alt-phone",
  "tenant-details",
  "profile",
];

export default function DynamicGuardedScreen() {
  const { screenId } = useParams();
  const navigate = useNavigate();
  // const [userData, setUserData] = useRecoilState(userDataAtom);
  // const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem(config.LOCAL_KEYS.SIGNUP_TOKEN);

  // // Fetch user data only on certain screens
  // useEffect(() => {
  //   const getUserData = async () => {
  //     try {
  //       setIsLoading(true);
  //       const data = await fetchData("user/me");
  //       setUserData(data);
  //     } catch (error) {
  //       console.error("Failed to fetch user data", error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };

  //   if (screenId === "tenant-details" || screenId === "profile") {
  //     getUserData();
  //   }
  // }, [screenId, setUserData]);

  // Navigate to sign-up if no token is found
  useEffect(() => {
    if (!token) {
      navigate("/sign-up");
      return;
    }
  }, [token, navigate]);

  if (!ALL_CONFIG_PATHS.includes(screenId)) return <NotFoundScreen />;

  // Return screen based on screenId
  switch (screenId) {
    case "tenant-details":
      return <TenantDetailsScreen />;
    case "profile":
      return <Profile />;
    case "invite":
      return <ClubInviteScreen />;
    default:
      return <DynamicScreen />;
  }
}
